<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("role.new") }}</span>
      </h2>

      <sweet-input v-model="form.name" :isValid="!$v.form.name.$error" @input="$v.form.name.$touch()" layout="vertical" :placeholder="$t('common.name')" :label="$t('role.name')" />

      <sweet-textarea v-model="form.description" :isValid="true" labelClass="mt-3" layout="vertical" :placeholder="$t('common.description')" :label="$t('common.description')" />

      <h4 class="mt-4">
        {{ $t("role.permissions") }}
        <span class="text-primary font-size-12 float-right hand" @click="toggleSelectAll">{{ !isSelectedAll ? $t("common.select-all") : $t("common.deselect-all") }}</span>
      </h4>
      <div
        v-for="item in permissions"
        :key="item.definition"
        @click="selectPermission(item)"
        :class="selectionMap[item.definition] ? 'border-primary bg-soft-primary' : 'border-gray'"
        class="mb-1 p-2 card card-body hand border "
      >
        <b> {{ item.name | translate }}</b>
        <div>
          {{ item.description | translate }}
        </div>
      </div>

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import sweetTextarea from "@/components/common/form/sweet-textarea.vue";

export default {
  components: { sweetTextarea },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      selections: [],
      selectionMap: {},
      isSelectedAll: false,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.resetForm();

        this.form = { ...this.prepareFormForEdit(v) };

        if (v && v.permissions) {
          v.permissions.forEach((i) => this.selectPermission(i));
        }
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`managementRole/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`managementRole/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`managementRole/isEditMode`];
    },
    permissions() {
      return this.$store.getters[`managementPermission/permissions`];
    },
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.$store.dispatch(`managementPermission/fetchAll`);
    },
    selectPermission(item) {
      if (this.selectionMap[item.definition]) {
        delete this.selectionMap[item.definition];
        this.selections = [...this.selections.filter((i) => i.definition != item.definition)];
      } else {
        this.selections = [...this.selections, item];
        this.selectionMap[item.definition] = item;
      }
      this.$forceUpdate();
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`managementRole/save`, {
          _id: this.form._id,
          name: this.form.name,
          description: this.form.description,
          permissions: Object.keys(this.selectionMap),
        });
        this.resetForm();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    toggleSelectAll() {
      this.isSelectedAll = !this.isSelectedAll;
      this.selections = [];
      this.selectionMap = {};
      if (this.isSelectedAll) {
        this.permissions.forEach((i) => this.selectPermission(i));
      }
    },
    resetForm() {
      this.isSelectedAll = false;
      this.form = {};
      this.selections = [];
      this.selectionMap = {};
    },
  },
};
</script>
